import {userById} from "./users"

// Check if user is Authenticated
export const isAuthorized = state => state.auth.currentUserId !== null

// Check if user is Guest
export const isGuest = state => !isAuthorized(state)

// Current user object
export const currentUser = state => userById(state)(currentUserId(state))
export const currentUserId = state => state.auth.currentUserId

export const currentUserIsEmployee = state => {
    let user = currentUser(state)
    return user && user.role === 'employee'
}

export const currentUserIsAdmin = state => {
    let user = currentUser(state)
    return user && user.role === 'admin'
}

export const appIsHydrated = state => {
    return state.auth.appHydrated
}